const formatTime = require('mn-utils/formatTime');

module.exports = (v, mask = '{dd}.{mm}.{yyyy} {HH}:{MM}') => formatTime(v, mask);
